import { Outlet, Link } from 'react-router-dom';
import { WorklynxIcon } from '@/components/icons/WorklynxIcon';
import { APP_NAME } from '@/lib/constants';
import { WorklynxBrandLockup } from '@/components/brand/WorklynxBrand';
import './auth-experience.css';

export function AuthLayout() {
  return (
    <div data-theme="light" className="wl-auth-shell">
      <header className="wl-auth-header">
        <Link to="/" aria-label={APP_NAME}>
          <WorklynxBrandLockup markClassName="h-10 w-10" textClassName="text-lg text-white" />
        </Link>
        <Link to="/" className="wl-auth-home-link">Back to WorkLynx</Link>
      </header>

      <main className="wl-auth-main">
        <section className="wl-auth-story" aria-label="WorkLynx product overview">
          <div className="wl-auth-kicker"><span /> Connected workforce operations</div>
          <h1>Your working day,<br />ready when you are.</h1>
          <p>Return to one secure workspace for rosters, people, live shifts and payroll-ready records.</p>

          <div className="wl-auth-product" aria-label="Fictional WorkLynx weekly roster preview">
            <div className="wl-auth-product-rail" aria-hidden="true"><span /><span /><span /></div>
            <div className="wl-auth-product-bar">
              <div><WorklynxIcon name="roster" size={16} /><strong>Weekly roster</strong></div>
              <span>20 July - 26 July</span>
            </div>
            {[
              ['Wed 22', '6:15 pm - 8:15 pm', 'Harbour Learning Centre'],
              ['Fri 24', '11:00 pm - 2:00 am', 'Riverside Arts Centre'],
              ['Sat 25', '9:00 am - 1:00 pm', 'Northside Library'],
            ].map(([day, time, site], index) => (
              <div className="wl-auth-shift" key={day}>
                <span>{day}</span>
                <div><strong>{time}</strong><small><WorklynxIcon name="gps" size={14} />{site}</small></div>
                <i className={index === 0 ? 'is-live' : ''}>{index === 0 ? 'Starting soon' : 'Published'}</i>
              </div>
            ))}
            <div className="wl-auth-product-foot">
              <span><WorklynxIcon name="time" size={14} /> 18.5 rostered hours</span>
              <span><WorklynxIcon name="check" size={14} /> Coverage confirmed</span>
            </div>
          </div>

          <div className="wl-auth-trust"><WorklynxIcon name="roles" size={20} /><span><strong>Protected by role-based access</strong>Every account enters the workspace through verified authentication.</span></div>
        </section>

        <section className="wl-auth-form-column">
          <div className="wl-auth-mobile-brand">
            <WorklynxBrandLockup markClassName="h-11 w-11" textClassName="text-xl text-white" />
          </div>
          <div className="wl-auth-form-intro">
            <span><i aria-hidden="true" /> Secure workspace access</span>
            <small>WorkLynx account</small>
          </div>
          <div className="wl-auth-form-card">
            <Outlet />
          </div>

          <footer className="wl-auth-footer">
            <p>&copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.</p>
            <nav>
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
              <Link to="/security">Security</Link>
            </nav>
          </footer>
        </section>
      </main>
    </div>
  );
}
